import { AcquisitionFilterParam } from "../types/acquisition";
import axios from "../utils/axiosClient";

export const fetchNewVsReturningData = async (params: AcquisitionFilterParam) => {
  const response = await axios.get("/acquisition/new-vs-returning", { params });
  return response.data;
};

export const fetchActivationRateOverTimeData = async (params: AcquisitionFilterParam) => {
  const response = await axios.get("/acquisition/activation-rate-over-time", { params });
  return response.data;
};

export const fetchFirstTouchData = async (params: AcquisitionFilterParam) => {
  const response = await axios.get("/acquisition/first-touch", { params });
  return response.data;
};

export const fetchSegmentLiftData = async (params: AcquisitionFilterParam) => {
  const response = await axios.get("/acquisition/segment-lift", { params });
  return response.data;
};
